module.exports = __webpack_public_path__ + "img/reciclaje.88c5b0e7.png";